// Shared labels/helpers for the HR module (งานบุคลากร)

export const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api')
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '')

export const fmtDateTH = (d) =>
  d ? new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'

export const fmtDateTimeTH = (d) =>
  d ? new Date(d).toLocaleString('th-TH', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'

export const fmtDays = (n) => {
  const v = parseFloat(n)
  if (Number.isNaN(v)) return '-'
  return Number.isInteger(v) ? String(v) : v.toFixed(1)
}

export const EMPLOYMENT_TYPES = {
  full_time: 'ประจำ',
  contract: 'สัญญาจ้าง',
  part_time: 'บางเวลา',
  temporary: 'ชั่วคราว',
}

// ประเภทใบอนุญาตประกอบวิชาชีพของคุรุสภา — เก็บเป็นคีย์ใน hl_type ไม่ใช่ข้อความไทย
// (ข้อความเปลี่ยนคำเมื่อไหร่ แถวเก่าจะกลายเป็นประเภทที่ไม่มีอยู่ทันที)
export const LICENSE_TYPES = {
  teacher:      'ครู',
  school_admin: 'ผู้บริหารสถานศึกษา',
  edu_admin:    'ผู้บริหารการศึกษา',
  supervisor:   'ศึกษานิเทศก์',
  other:        'อื่นๆ',
}

export const STAFF_STATUS = {
  active:   { label: 'ปฏิบัติงาน', bg: 'success' },
  on_leave: { label: 'ลาพัก',      bg: 'warning' },
  resigned: { label: 'ลาออก',      bg: 'secondary' },
  retired:  { label: 'เกษียณ',     bg: 'dark' },
}

export const TRAINING_TYPES = {
  training: { label: 'อบรม',   bg: 'info' },
  meeting:  { label: 'ประชุม',  bg: 'primary' },
  activity: { label: 'กิจกรรม', bg: 'success' },
  internal: { label: 'ภายในโรงเรียน', bg: 'dark' },
}

// งานภายในโรงเรียนระบุช่วงคาบได้ (ประเภทอื่นไม่ได้ ไปข้างนอกแล้วไม่ได้กลับมาสอนคาบอื่น)
export const TRAINING_TYPES_WITH_PERIOD = ['internal']

// 'คาบ 3 - 5' / 'คาบ 3' — คืน '' เมื่อไม่ได้ระบุคาบ ซึ่งแปลว่าไม่อยู่ทั้งวัน
export const fmtPeriodRange = (start, end) => {
  if (start == null || start === '' || end == null || end === '') return ''
  return Number(start) === Number(end) ? `คาบ ${start}` : `คาบ ${start} - ${end}`
}

export const LEAVE_STATUS = {
  pending:   { label: 'รออนุมัติ',  bg: 'warning' },
  approved:  { label: 'อนุมัติ',    bg: 'success' },
  rejected:  { label: 'ไม่อนุมัติ', bg: 'danger' },
  cancelled: { label: 'ยกเลิก',     bg: 'secondary' },
}

// เจ้าตัวยกเลิกใบลาเองได้ตอนรออนุมัติ และตอนที่อนุมัติแล้วแต่ยังไม่ถึงวันเริ่มลา —
// ต้องตรงกับเงื่อนไขใน hrModel.cancelOwnRequest ซึ่งเป็นตัวตัดสินจริง (ปุ่มนี้แค่ซ่อนไว้เฉยๆ)
// lr_start_date มาจาก DATE_FORMAT เป็นสตริง 'YYYY-MM-DD' แล้ว เทียบข้อความกับวันนี้ตามเวลาเครื่องได้ตรงๆ
export const canCancelOwnLeave = (r) => {
  if (!r) return false
  if (r.lr_status === 'pending') return true
  if (r.lr_status !== 'approved') return false
  return String(r.lr_start_date).slice(0, 10) > new Date().toLocaleDateString('en-CA')
}

// ประกอบ FormData ของเอกสาร/ใบอนุญาต — หน้าของเจ้าตัวกับหน้าของงานบุคลากรส่งชุดเดียวกัน
// ช่องที่ว่างส่งเป็นสตริงว่าง ฝั่ง server แปลงเป็น NULL ให้ (ไม่ส่งไปเลยจะกลายเป็น undefined
// ที่ multer ไม่ใส่ลง req.body แล้ว UPDATE จะเขียนทับด้วย null โดยไม่ได้ตั้งใจ)
// ไฟล์ไม่แนบ = เก็บไฟล์เดิมไว้ตอนแก้ไข
export const documentFormData = (d) => {
  const fd = new FormData()
  fd.append('hd_type', d.hd_type || '')
  fd.append('hd_title', d.hd_title || '')
  fd.append('hd_issue_date', d.hd_issue_date || '')
  fd.append('hd_expire_date', d.hd_expire_date || '')
  if (d.file) fd.append('document', d.file)
  return fd
}

export const licenseFormData = (l) => {
  const fd = new FormData()
  if (l.hl_id) fd.append('hl_id', l.hl_id)
  fd.append('hl_type', l.hl_type || 'teacher')
  fd.append('hl_number', l.hl_number || '')
  fd.append('hl_issue_date', l.hl_issue_date || '')
  fd.append('hl_expire_date', l.hl_expire_date || '')
  fd.append('hl_note', l.hl_note || '')
  if (l.file) fd.append('license', l.file)
  return fd
}

// สถานะวันหมดอายุของเอกสารในแฟ้มประวัติ — null = ไม่มีวันหมดอายุ หรือยังอีกไกล
// ประกอบวันที่เป็นเวลาท้องถิ่นทีละส่วน ไม่ผ่าน new Date('YYYY-MM-DD') ซึ่งอ่านเป็น UTC
// แล้วเพี้ยนไปหนึ่งวันเมื่อเทียบกับวันนี้ตามเวลาเครื่อง
export const docExpiryState = (value) => {
  if (!value) return null
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return null
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const days = Math.round((new Date(y, m - 1, d) - today) / 86400000)
  if (days < 0) return { label: 'หมดอายุแล้ว', bg: 'danger' }
  if (days <= 30) return { label: `อีก ${days} วัน`, bg: 'warning' }
  return null
}

// 'HH:MM' or 'HH:MM:SS' -> 'HH:MM น.'
export const fmtTime = (t) => (t ? `${String(t).slice(0, 5)} น.` : '-')

export const toBE = (year) => Number(year) + 543
export const toCE = (yearBE) => Number(yearBE) - 543
